import { render, staticRenderFns } from "./AS_CsrPolicy.vue?vue&type=template&id=7df865ae&scoped=true&"
import script from "./AS_CsrPolicy.vue?vue&type=script&lang=js&"
export * from "./AS_CsrPolicy.vue?vue&type=script&lang=js&"
import style0 from "./AS_CsrPolicy.vue?vue&type=style&index=0&id=7df865ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df865ae",
  null
  
)

export default component.exports